// extracted by mini-css-extract-plugin
export default {"metadataContainer":"SubIssuesListItem-module__metadataContainer--Z6neq","itemMetadataContainer":"SubIssuesListItem-module__itemMetadataContainer--IR8bE"};